// extracted by mini-css-extract-plugin
module.exports = {"container":"NewIntermediaryForm_container__2I7gP"};